import { NgModule } from '@angular/core';

import { CloseIconComponent, DrawerComponent, ModalComponent } from '../public-api';

@NgModule({
  imports: [
    ModalComponent,
    DrawerComponent,
    CloseIconComponent
  ],
  exports: [
    ModalComponent,
    DrawerComponent,
    CloseIconComponent
  ],
})
export class GeneAiUiModule { }
